
import React, { Component } from 'react';
import MainLayout from '../layout/layout';
import {  Redirect } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'react-block-ui/style.css';
import UnderConstruction from '../Images/under-construction.gif';

class Construction extends Component{

    constructor(props){
        super(props);
        this.state = {
        };
    }   
    render(){
        if (!sessionStorage.getItem('token')) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div  id="divContainer">
             <MainLayout/>
                <div className="container" >
                <div className="row">
                        <div className="col s12">
                            <div className="card Logs">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-5 offset-4">
                                            <h4><strong>Under Construction Page</strong></h4>
                                        </div>
                                    </div>                                   
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-5 offset-4">
                                            <img src={UnderConstruction} title="UnderConstruction" alt="" style={{ width: '50%'}} />
                                        </div>
                                    </div>                                     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>         
        );
        
    }
}

export default Construction;


// WEBPACK FOOTER //
// ./src/underConstruction/construction.jsx